import React from "react";
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import { ReactSession } from 'react-client-session';

import { Helpers } from "../../config/Helpers";
import {toast} from "react-toastify";
import queryString from "query-string";

class List extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            sessStore: (ReactSession.get("sess_order_store")) ? ReactSession.get("sess_order_store") : '',
            branchCode: (ReactSession.get("branch_code")) ? ReactSession.get("branch_code") : 'CBNG-18-020001',
            search: '',
            loading: true,
            locationData: [],
            urlParam: queryString.parse(window.location.search),
        };
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            const kodeOrder = (this.state.urlParam.trxid) ? base64_decode(this.state.urlParam.trxid) : '';
            const type = (this.state.urlParam.type) ? this.state.urlParam.type : '';

            this.setState({
                kodeTransaksiOrder: kodeOrder,
                type: type
            }, () => {
                this.getLocations();
            });
        }
    }

    getLocations = () => {
        this.setState({ loading: true });

        Helpers.getListLokasiPengiriman('', this.state.sessEmail, this.state.branchCode).then(res => {
            this.setState({
                locationData: (res) ? res : [],
                loading: false
            });
        })
    };

    getFiltered = () => {
        if(!this.state.search){
            return this.state.locationData;
        }

        const str = this.state.search.toUpperCase();
        const searchableKeys = ["Nama", "Penerima", "NoPonsel", "PinPoint"];

        return this.state.locationData.filter((item) => {
            return searchableKeys.some((key) => ((item[key]) ? item[key] : '').toUpperCase().includes(str));
        });
    };

    handleSearch = (e) => {
        e.preventDefault();
        this.setState({ search: this.state.search });
    };

    handleLocationClick = (object) => {
        let check_jarak = (parseFloat(object.Jarak)/1000).toFixed(2);
        if(check_jarak > 200){
            toast.error(Helpers.MSG_ERROR_DISTANCE);

            ReactSession.set("sess_order_kodelokasi", '');
            ReactSession.set("sess_order_jarak", '0');
            ReactSession.set("sess_order_penerima", '');
            ReactSession.set("sess_order_noponsel", '');
            ReactSession.set("sess_order_latitude", '0');
            ReactSession.set("sess_order_longitude", '0');
            ReactSession.set("sess_order_pinpoint", '');
            ReactSession.set("sess_order_jasakirim", '0');
        }else{
            ReactSession.set("sess_order_kodelokasi", object.KodeLokasi);
            ReactSession.set("sess_order_lokasi_nama", object.Nama);
            ReactSession.set("sess_order_jarak", object.Jarak);
            ReactSession.set("sess_order_penerima", object.Penerima);
            ReactSession.set("sess_order_noponsel", object.NoPonsel);
            ReactSession.set("sess_order_latitude", object.Latitude);
            ReactSession.set("sess_order_longitude", object.Longitude);
            ReactSession.set("sess_order_pinpoint", object.PinPoint);
            ReactSession.set("sess_order_jasakirim", object.EstimasiJasaKirim2);

            if(this.state.type){
                if(this.state.type === 'change_delivery'){
                    window.location.href = './change-delivery-method?trxid=' + base64_encode(this.state.kodeTransaksiOrder);
                }else{
                    window.location.href = './checkout';
                }
            }else{
                window.location.href = './checkout';
            }
        }
    };

    handleLocationEdit = (e, object) => {
        e.stopPropagation();
        window.location.href = './location-manage?trxid=' + base64_encode(object.KodeLokasi) + '&action=update';
    };

    handleLocationDelete = (e, object) => {
        e.stopPropagation();

        if (window.confirm('Apakah anda yakin akan menghapus alamat ini?')) {
            Helpers.saveLokasiPengiriman(
                this.state.sessEmail,
                object.KodeLokasi,
                this.state.sessStore,
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                'delete'
            ).then(res => {
                if(res.length > 0){
                    if(res[0].alert == 'success'){
                        this.getLocations();
                    }

                    toast[res[0].alert](res[0].message);
                }else{
                    toast.error(Helpers.MSG_ERROR);
                }
            })
        }
    };

    render() {
        const filtered = this.getFiltered();

        return (
            <>
                <main className="main pages detail-page-wrap">
                    <div className="detail-topbar">
                        <a href="./" className="detail-topbar-back"><i className="fi-rs-arrow-small-left"></i></a>
                        <h1 className="detail-topbar-title">Daftar Alamat</h1>
                    </div>

                    <div className="location-search-row">
                        <form method="post" onSubmit={(e) => {this.handleSearch(e)}}>
                            <i className="fi-rs-search location-search-icon"></i>
                            <input type="text" placeholder="Cari lokasi" value={this.state.search} onChange={e => this.setState({search: e.target.value})}/>
                            {
                                this.state.search && (
                                    <i className="fi-rs-cross-circle location-search-clear" onClick={() => this.setState({search: ''})}></i>
                                )
                            }
                        </form>
                        <a href={'./location-manage?trxid=&action=insert'} className="location-add-btn">
                            <i className="fi-rs-plus"></i> Tambah
                        </a>
                    </div>

                    <div className="detail-wrap">
                        {
                            this.state.loading ? (
                                <div className="detail-card">
                                    <div className="detail-card-head">
                                        <span className="detail-card-accent"></span>
                                        <span className="detail-card-title">Memuat data...</span>
                                    </div>
                                </div>
                            ) : filtered.length > 0 ? (
                                filtered.map((object, i) => (
                                    <div className="location-card" key={i} onClick={() => {this.handleLocationClick(object)}}>
                                        <div className="location-card-icon">
                                            <i className="fi-rs-marker"></i>
                                        </div>
                                        <div className="location-card-body">
                                            <div className="location-card-name">{object.Nama}</div>
                                            <div className="location-card-recipient">{(object.Penerima || '').toUpperCase()} - {object.NoPonsel}</div>
                                            <div className="location-card-address">{object.PinPoint}</div>
                                        </div>
                                        <div className="location-card-actions">
                                            <button type="button" className="location-card-action-btn" onClick={(e) => {this.handleLocationEdit(e, object)}}>
                                                <i className="fi-rs-pencil"></i>
                                            </button>
                                            <button type="button" className="location-card-action-btn danger" onClick={(e) => {this.handleLocationDelete(e, object)}}>
                                                <i className="fi-rs-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="order-empty">
                                    <i className="fi-rs-marker"></i>
                                    <p>Belum ada lokasi pengiriman</p>
                                </div>
                            )
                        }
                    </div>
                </main>
            </>
        );
    }
}

export default List;
